export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-C1.91db2308.jpg";